import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import queryString from 'query-string';
// import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import InfiniteScroll from 'react-infinite-scroller';
import Header from '../../components/Header';
// import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import AcceptPopup from '../../components/molecules/AcceptPopup';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getShops } from '../../actions/Shop';
import {
  downloadBookings,
  getBookings,
  bookingsEnabled,
  DOWNLOAD_BOOKING_SUCCESS,
  EDIT_ENABLE_BOOKING_SUCCESS,
  GET_BOOKING_SUCCESS
} from '../../actions/Booking';
import MenuBox from '../../components/MenuBox';
import NotifyPopupShop from '../../components/molecules/NotifyPopupShop';
import { getAccounts } from '../../actions/Accounts';
import ShowHideSwitchButton from '../../components/atoms/ShowHideSwitchButton';

const Accordion = withStyles({
  root: {
    border: 0,
    boxShadow: 'none',
    '&::before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const re = /^[0-9\b]+$/;

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    '&$expanded': {
      minHeight: 48
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0,
    display: 'block'
  }
})(MuiAccordionDetails);

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      backgroundColor: '#F7F7F7',
      margin: '0 auto'
    }
  },
  rootClassic: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  mainContent: {
    padding: 15
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10
  },
  mainPaper: {
    position: 'relative'
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 20px 20px 20px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    marginTop: 0
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  textField300: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  fs24: {
    fontSize: '24px'
  },
  fs20: {
    fontSize: '20px'
  },
  buttonCenter: {
    padding: '10px',
    textAlign: 'center'
  },
  gochiBox: {
    padding: 12,
    borderTop: '1px solid #DBDBDB'
  },
  gochiHeader: {
    padding: '10px',
    color: '#ffffff',
    fontSize: 12,
    textAlign: 'center',
    backgroundColor: '#717171',
    display: 'flex',
    // justifyContent: 'center',
    alignItems: 'flex-end',
    position: 'relative',
    marginBottom: 20,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: '50%',
      bottom: '-12px',
      transform: 'translateY(-50%)',
      display: 'inline-block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 5px 0 5px',
      borderColor: '#717171 transparent transparent transparent'
    }
  },
  couponNo: {
    margin: '0 5px',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: '20px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  bkId: {
    position: 'absolute',
    right: '10px'
  },
  titleBkId: {
    marginRight: '5px',
    display: 'inline-block',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  textCompare: {
    display: 'inline-block',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  remainCoupon: {
    backgroundColor: '#FFD0D5',
    color: '#000000',
    height: '38px',

    '&:before': {
      borderColor: '#FFD0D5 transparent transparent transparent'
    }
  },
  gochiCoupon: {
    backgroundColor: '#D8EBFF',
    color: '#000000',

    '&:before': {
      borderColor: '#D8EBFF transparent transparent transparent'
    }
  },
  tableInfo: {
    width: '100%'
  },
  tableInfoCellHeader: {
    padding: '2px 10px',
    width: '95px',
    borderBottom: '2px solid #ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000',
    textAlign: 'center',
    backgroundColor: '#F7F7F7'
  },
  tableInfoCell: {
    padding: '2px 10px',
    borderBottom: '2px solid transparent',
    fontSize: '12px',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-all'
  },
  textRed: {
    color: '#F44A4A',
    fontWeight: '500',
    fontSize: '14px'
  },
  boxMessage: {
    padding: '8px 10px',
    border: '1px solid #DBDBDB',
    borderRadius: 6,
    fontSize: 12,
    color: '#000000',
    marginTop: 15
  },
  messageTtl: {
    marginBottom: 5,
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  iconReply: {
    fontSize: 18,
    display: 'inline-block',
    marginRight: 5
  },
  boxMessageReply: {
    fontSize: 12,
    paddingLeft: 10,
    marginTop: 10,
    whiteSpace: 'pre-line'
  },
  inputRoot: {
    width: '100%'
  },
  inputMessage: {
    borderColor: '#DBDBDB',
    borderRadius: 0,
    padding: '10px 15px',
    height: 70,
    fontSize: 12
  },
  buttonSend: {
    marginLeft: 'auto',
    height: 22,
    fontSize: 12,
    padding: 0
  },
  messageReplyBox: {
    backgroundColor: '#F7F7F7',
    borderRadius: 6,
    padding: '8px 10px',
    whiteSpace: 'pre-line'
  },
  textId: {
    fontSize: 10,
    color: '#777777',
    display: 'inline-block',
    marginLeft: 5
  },
  textCenter: {
    textAlign: 'center',
    marginTop: 15
  },
  searchCollapseBox: {
    marginBottom: '20px'
  },
  collapseBtn: {
    minHeight: 'unset !impotant',
    margin: '0',
    padding: 0
  },
  divAccept: {
    marginTop: 5,
    textAlign: 'center'
  },
  btnAccept: {
    textAlign: 'center'
  },
  boxSwitch: {
    display: 'flex'
  },
  titleSwitch: {
    fontSize: '12px'
  },
  headerTitleSwitch: {
    fontSize: '14px',
    fontWeight: 'bold'
  },
  contentSwitch: {
    minWidth: '80px',
    textAlign: 'center'
  },
  extendClasses: {
    margin: 0
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops,
      account: state.accounts.account,
      bookings: state.bookings.list.list,
      totalCount: state.bookings.list.totalCount
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          downloadBookings,
          bookingsEnabled,
          getBookings,
          getShops,
          getAccounts
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuId', 'setMenuId', ''),
  withState('bookingUsername', 'setBookingUserName', ''),
  withState('bookingTimeFrom', 'setBookingTimeFrom', ''),
  withState('bookingTimeTo', 'setBookingTimeTo', ''),
  withState('bookingId', 'setBookingId', ''),
  withState('listBooking', 'setListBooking', []),
  withState('hasMore', 'setHasMore', false),
  withState('nextHref', 'setNextHref', 1),
  withState('messageReply', 'setMessageReply', []),
  withState('shopReplyText', 'setShopReplyText', ''),
  withState('shashokuShopReplyText', 'setShashokuShopReplyText', ''),
  withState('shashokuMessageReply', 'setShashokuMessageReply', []),
  withState('childKey', 'setChildKey', 0),
  withState('openNotifyPopup', 'setOpenNotifyPopup', false),
  withState('textTitle', 'setTextTitle', ''),
  withState('textMessage', 'setTextMessage', ''),
  withState('Status', 'setStatus', null),
  withState('dataAccept', 'setDataAccept', []),
  withState('expandedCollapse', 'setExpandedCollapse', false),
  withState('gochisAll', 'setGochisAll', []),
  withState('showGochiPrice', 'setShowGochiPrice', 1),
  withState('openAcceptPopup', 'setOpenAcceptPopup', false),
  withState('updateOpenAcceptPopup', 'setUpdateOpenAcceptPopup', false),
  withState('perPage', 'setPerPage', 10),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    loadGochiData: props => page => {
      setTimeout(() => {
        props.updateLoading(true);
        props.updateOpenProgress(true);
        const searchKey = {
          bookingId: props.bookingId,
          status: props.Status,
          bookingUsername: props.bookingUsername,
          bookingTimeFrom: props.bookingTimeFrom,
          bookingTimeTo: props.bookingTimeTo,
          limit: 10,
          page
        };
        // let list = [];
        // if (page > 1) {
        //   list = props.listBooking;
        // } else {
        //   list = [];
        //   props.setNextHref(1);
        // }

        // if (searchFlag) {
        props.actions
          .getBookings(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.updateLoading(false);

            let list = [];
            if (page > 1) {
              list = props.listBooking;
            } else {
              list = [];
              props.setNextHref(1);
            }

            if (data.type === GET_BOOKING_SUCCESS) {
              if (data.payload.list) {
                data.payload.list.map(gochi => {
                  return list.push(gochi);
                });
                props.setListBooking(list);
                if (data.payload.offset + 10 < data.payload.totalCount) {
                  props.setHasMore(true);
                } else {
                  props.setHasMore(false);
                }
              }
            }

            // if (data.type === 'GET_GOCHIS_SHOP_SUCCESS') {
            //   if (data.payload.result) {
            //     props.setGochisAll(data.payload.result);
            //     for (let i = 0; i < data.payload.result.length; i += 1) {
            //       if (i < props.perPage) {
            //         list.push(data.payload.result[i]);
            //       }
            //     }
            //     // data.payload.gochisAll.map(gochis => {
            //     //   return list.push(gochis);
            //     // });
            //     props.setListBooking(list);
            //     if (data.payload.result.length > props.perPage) {
            //       props.setHasMore(true);
            //     } else {
            //       props.setHasMore(false);
            //     }
            //   }
            // }
          })
          .catch(error => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            console.log('error', error);
            props.setNextHref(1);
          });
        // } else {
        //   for (let i = 0; i < props.gochisAll.length; i += 1) {
        //     if (i < page * props.perPage && i >= (page - 1) * props.perPage) {
        //       list.push(props.gochisAll[i]);
        //       if (list.length - props.gochisAll.length < 0) {
        //         props.setHasMore(true);
        //       } else {
        //         props.setHasMore(false);
        //       }
        //       props.setListBooking(list);
        //       props.updateOpenProgress(false);
        //       props.setResultMessage('');
        //       props.updateLoading(false);
        //     }
        //   }
        // }
      }, 100);
    }
  }),
  lifecycle({
    async componentDidMount() {
      console.log('binhdp');
      this.props.setChildKey(this.props.childKey + 1);
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' });
      // this.props.loadGochiData(1, true);
      // this.props.handleChangePage(null, 0);
    },
    componentUnmount() {
      const list = [{ foo: undefined }];
      this.props.setListBooking(list);
      console.log(this.props.listBooking);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    shops,
    checkSession,
    account,
    updateOpenDrawer,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    bookingUsername,
    setBookingUserName,
    bookingId,
    setBookingId,
    Status,
    setStatus,
    handleRedirect,
    bookingTimeFrom,
    setBookingTimeFrom,
    bookingTimeTo,
    setBookingTimeTo,
    hasMore,
    loadGochiData,
    listBooking,
    childKey,
    setListBooking,
    nextHref,
    setNextHref,
    menuId,
    textTitle,
    textMessage,
    openNotifyPopup,
    setOpenNotifyPopup,
    expandedCollapse,
    setExpandedCollapse,
    showGochiPrice,
    setShowGochiPrice,
    dataAccept,
    setDataAccept,
    openAcceptPopup,
    setOpenAcceptPopup,
    setUpdateOpenAcceptPopup
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    // const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    // const isSecretariat =
    //   typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    // const isDeveloper =
    //   typeof account !== 'undefined' && account.role === 'DEVELOPER';
    // const roles = {
    //   isShop,
    //   isGroup,
    //   isSecretariat,
    //   isDeveloper
    // };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limit = 100;
    if (rowsPerPage) {
      limit = rowsPerPage.textContent;
    }
    let searchKey = {
      bookingId,
      Status,
      bookingUsername,
      bookingTimeFrom,
      bookingTimeTo,
      limit: menuId ? 10 : limit
    };

    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const para = queryString.parse(window.location.search);
    // check if is account shop
    if (!isShop && !isReleased && !para.notify) {
      console.log('isShop', isShop);
      console.log('isReleased', isReleased);
      console.log('para.notify', para.notify);
      handleRedirect('/shops');
    }

    const searchAction = () => {
      setExpandedCollapse(false);
      setListBooking([]);
      setNextHref(1);

      searchKey = {
        ...searchKey
      };
      loadGochiData(1, true);
      actions.getShops().then(data => {
        checkSession(data);
        if (data.payload.shops['0']) {
          setShowGochiPrice(data.payload.shops['0'].bookingEnabled);
        }
      });
    };

    useEffect(() => {
      searchAction();
    }, [para.notify]);

    const loadMoreGochis = () => {
      setNextHref(nextHref + 1);
      searchKey = {
        ...searchKey
      };
      loadGochiData(nextHref + 1);
    };

    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .downloadBookings(searchKey)
        .then(data => checkSession(data));
      if (response.type === DOWNLOAD_BOOKING_SUCCESS) {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        downloadCsvBlob(response.payload, `${timeStamp}_gochi_info.csv`);
      } else {
        setResultMessage('ごち情報ダウンロードに失敗しました。');
        updateLoading(false);
      }
    };

    const showHideOpenAction = async param => {
      updateLoading(true);
      updateOpenProgress(true);
      const dataParams = {
        bookingEnabled: !param ? 1 : 0
      };
      if (account) {
        await actions
          .bookingsEnabled(account.shopId, dataParams)
          .then(data => {
            // console.log(data);
            if (data.type === EDIT_ENABLE_BOOKING_SUCCESS) {
              updateOpenProgress(false);
              setShowGochiPrice(!param);
              updateLoading(false);
            }
          })
          .catch(() => {
            updateOpenProgress(false);
            updateLoading(false);
          });
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const acceptOpenAction = idBooking => {
      setOpenAcceptPopup(true);
      setDataAccept(idBooking);
    };

    return (
      <>
        <div className={classes.root}>
          <Header
            onMenuClick={() => {
              updateOpenDrawer(true);
            }}
          />

          <div className={classes.mainContent}>
            <div className={classes.pageTitileDiv}>
              <Typography color="textPrimary" className={classes.fs24}>
                お客様からの連絡
              </Typography>
            </div>
            <div className={classes.searchCollapseBox}>
              <div className={classes.boxSwitch}>
                <div className={classes.titleSwitch}>
                  <div className={classes.headerTitleSwitch}>
                    連絡機能を利用する
                  </div>
                  <div>{shops.bookingEnabled}</div>
                  <div>
                    連絡機能を利用するとお客様からのご相談を受付けることができ、そのメッセージへ返信することができます。
                  </div>
                </div>
                <div className={classes.contentSwitch}>
                  <div>
                    <ShowHideSwitchButton
                      params={showGochiPrice}
                      onClickAction={showHideOpenAction}
                      showHide={showGochiPrice ? 1 : 0}
                    />
                  </div>
                </div>
              </div>
              <Accordion
                className={classes.boxCollapse}
                expanded={expandedCollapse}
                onChange={() => {
                  setExpandedCollapse(!expandedCollapse);
                }}
              >
                <div className={classes.textTitleDiv}>
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon className={classes.arrowCustom} />
                    }
                    aria-controls="statistic-pannel"
                    id="statistic-pannel"
                    className={classes.collapseBtn}
                  >
                    <Typography
                      color="textSecondary"
                      className={[classes.fs20, classes.extendClasses]}
                    >
                      検索
                    </Typography>
                  </AccordionSummary>
                </div>

                <AccordionDetails>
                  <Paper className={classes.mainPaper} elevation={1}>
                    <div className={classes.searchForm}>
                      <div>
                        <TextField
                          label="連絡番号"
                          placeholder="部分一致"
                          type="text"
                          className={classes.textField}
                          margin="normal"
                          value={bookingId}
                          onChange={e => {
                            if (
                              e.target.value === '' ||
                              re.test(e.target.value)
                            ) {
                              setBookingId(e.target.value);
                            }
                          }}
                        />
                        <TextField
                          select
                          label="連絡の状態"
                          className={classes.textField}
                          margin="normal"
                          value={Status}
                          onChange={e => {
                            setStatus(e.target.value);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        >
                          <MenuItem id="">選択なし</MenuItem>
                          <MenuItem key="0" value="WAITING">
                            進行中
                          </MenuItem>
                          <MenuItem key="1" value="FINISHED">
                            完了
                          </MenuItem>
                        </TextField>
                        <TextField
                          label="連絡者名"
                          placeholder="部分一致"
                          type="search"
                          className={classes.textField}
                          margin="normal"
                          value={bookingUsername}
                          onChange={e => {
                            setBookingUserName(e.target.value);
                          }}
                        />
                      </div>
                      <div>
                        <TextField
                          label="来店希望日(From)"
                          type="date"
                          className={classes.textField150}
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={bookingTimeFrom}
                          onChange={e => {
                            setBookingTimeFrom(e.target.value);
                          }}
                        />
                        <TextField
                          label="来店希望日(To)"
                          type="date"
                          className={classes.textField150}
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={bookingTimeTo}
                          onChange={e => {
                            setBookingTimeTo(e.target.value);
                          }}
                        />
                      </div>
                      <div className={classes.textLeft}>
                        <SearchButton onClickAction={searchAction} />
                      </div>
                    </div>
                  </Paper>
                </AccordionDetails>
              </Accordion>
            </div>

            <Paper>
              <div className={classes.buttonCenter}>
                <CsvDownloadButton onClickAction={csvDownloadAction} />
              </div>
              <div className={classes.infiniteScroll}>
                <div
                  className="select-block-body m-0"
                  key={`box${childKey}`}
                  // style={{ height: '1000px', overflow: 'auto' }}
                >
                  <div className="lst-friends h-100" key={`list${childKey}`}>
                    {listBooking &&
                      listBooking.map(booking => {
                        const key = `${booking.bookingId}`;
                        return (
                          <>
                            {booking.status === 'FINISHED' ? (
                              <div className={classes.gochiBox} key={key}>
                                <div
                                  className={classNames(
                                    classes.remainCoupon,
                                    classes.gochiHeader
                                  )}
                                >
                                  <b>使用状況 </b>
                                  <span className={classes.couponNo}>完了</span>
                                  <span className={classes.bkId}>
                                    <span className={classes.titleBkId}>
                                      連絡番号
                                    </span>
                                    <span className={classes.textCompare}>
                                      {booking.bookingId}
                                    </span>
                                  </span>
                                </div>

                                <Table>
                                  <TableBody className={classes.tableInfo}>
                                    <TableRow className={classes.tableInfoRow}>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        相談された日
                                      </TableCell>
                                      <TableCell
                                        className={classNames(
                                          classes.tableInfoCell,
                                          classes.textRed
                                        )}
                                      >
                                        {booking.bookingTime}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        連絡者名
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.bookingUsername}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        メニュー名
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.menuName}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        税込価格
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.includedTaxPrice}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        電話番号
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.phoneNumber}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        メッセージ
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.bookingMessage}
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </div>
                            ) : (
                              <div className={classes.gochiBox} key={key}>
                                <div
                                  className={classNames(
                                    classes.gochiCoupon,
                                    classes.gochiHeader
                                  )}
                                >
                                  <b>使用状況 </b>
                                  <span className={classes.couponNo}>
                                    進行中
                                  </span>
                                  <span className={classes.bkId}>
                                    <span className={classes.titleBkId}>
                                      連絡番号
                                    </span>
                                    <span className={classes.textCompare}>
                                      {booking.bookingId}
                                    </span>
                                  </span>
                                </div>

                                <Table>
                                  <TableBody className={classes.tableInfo}>
                                    <TableRow className={classes.tableInfoRow}>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        相談された日
                                      </TableCell>
                                      <TableCell
                                        className={classNames(
                                          classes.tableInfoCell,
                                          classes.textRed
                                        )}
                                      >
                                        {booking.bookingTime}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        連絡者名
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.bookingUsername}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        メニュー名
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.menuName}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        税込価格
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.includedTaxPrice}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        電話番号
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.phoneNumber}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        メッセージ
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {booking.bookingMessage}
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                                <div className={classes.divAccept}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size="xs"
                                    onClick={() =>
                                      acceptOpenAction(booking.bookingId)
                                    }
                                    className={classes.btnAccept}
                                  >
                                    お客様に連絡する
                                  </Button>
                                </div>
                              </div>
                            )}
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </Paper>

            {hasMore && (
              <div className={classes.textCenter}>
                <Button
                  variant="contained"
                  color="primary"
                  siz="xs"
                  // className={classes.buttonSend}
                  onClick={() => {
                    loadMoreGochis();
                  }}
                >
                  もっと見る
                </Button>
              </div>
            )}
          </div>

          <div>
            <Modal open={openNotifyPopup}>
              <NotifyPopupShop
                setOpenNotifyPopup={setOpenNotifyPopup}
                textTitle={textTitle}
                textMessage={textMessage}
              />
            </Modal>
          </div>

          <div>
            <Modal open={openAcceptPopup}>
              <AcceptPopup
                setOpenAcceptPopup={setOpenAcceptPopup}
                setUpdateOpenAcceptPopup={setUpdateOpenAcceptPopup}
                setDataAccept={dataAccept}
                handleChangePage={loadGochiData}
                checkShop="true"
              />
            </Modal>
          </div>

          <ProgressDialog
            openProgress={openProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
          />
          <MenuBox account={account} />
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
